export enum AssessmentSidebarTab {
  artifacts = "Items",
  workHistory = "Work history",
  askAI = "Ask AI",
  roles = "Roles",
  reviews = "Reviews",
}
